
import React, {useState} from 'react';
import * as R from 'ramda';

export const Cookies = () => {
	const [showBanner, setShowBanner] = useState(true);
	const cookieName = "cookieAcceptance";
	function setCookie(name,value,days) {
		var expires = "";
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days*24*60*60*1000));
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "")  + expires + "; path=/";
	}
	function getCookie(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
		}
		return null;
	}

	const cookie = getCookie(cookieName);
	if(!R.isNil(cookie) || !showBanner){
		return '';
	}

	return (
		<div className="block bg-black text-white z-max py-3 fixed-bottom mt-3" id="cookie-law-info-bar">
			<div className="container-fluid container-modal">
				<p className="fs-3 mb-1">
					Nous déposons uniquement des cookies strictement nécessaires au bon fonctionnement de notre site web qui ne peuvent pas être désactivés.
				</p>
				<p className="fs-3 mb-2">
					
				</p>
				<p className="fs-3 mb-2">
					Pour en savoir davantage, contactez-nous pour obtenir notre politique de confidentialité et notre politique de gestion des cookies.
				</p>
				<button type="button" className="btn btn-aux" onClick={() => {
					setCookie(cookieName, true, 3650);
					setShowBanner(false);
				}}>Accepter</button>
				{/* <button type="button" className="btn btn-link text-aux">Continue without agreeing →</button> */}
			</div>
		</div>

	)
}